import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Auth.css';

const Signup = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signup, isAuthenticated } = useAuth();
  
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/tryon', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleGoogleSignup = () => {
    // Redirect to backend OAuth endpoint
    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    window.location.href = `${backendUrl}/api/auth/google/login`;
  };

  const handleEmailSignup = async (e) => {
    e.preventDefault();
    setError('');

    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }

    setLoading(true);

    const result = await signup(name, email, password);

    if (result.success) {
      navigate('/tryon', { replace: true });
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className='auth-page'>
      <div className='auth-container'>
        <div className='auth-header'>
          <h1 className='auth-logo' onClick={() => navigate('/')}>FITTTY.AI</h1>
          <h2>Create Account</h2>
          <p>Start your virtual try-on journey with 10 free credits</p>
        </div>

        {error && <div className='auth-error'>{error}</div>}

        <button className='google-btn' onClick={handleGoogleSignup} disabled={loading}>
          <img src='https://www.google.com/favicon.ico' alt='Google' />
          Continue with Google
        </button>

        <div className='auth-divider'>
          <span>OR</span>
        </div>

        <form onSubmit={handleEmailSignup} className='auth-form'>
          <div className='form-group'>
            <label>Full Name</label>
            <input
              type='text'
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder='John Doe'
              required
              disabled={loading}
            />
          </div>

          <div className='form-group'>
            <label>Email</label>
            <input
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder='your@email.com'
              required
              disabled={loading}
            />
          </div>

          <div className='form-group'>
            <label>Password</label>
            <input
              type='password'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder='••••••••'
              required
              minLength='6'
              disabled={loading}
            />
          </div>

          <div className='form-group'>
            <label>Confirm Password</label>
            <input
              type='password'
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              placeholder='••••••••'
              required
              minLength='6'
              disabled={loading}
            />
          </div>

          <button type='submit' className='auth-submit-btn' disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <div className='auth-footer'>
          <p>
            Already have an account?{' '}
            <Link to='/login'>Sign in</Link>
          </p>
        </div>

        <div className='auth-benefits'>
          <h3>What you get:</h3>
          <ul>
            <li>✨ 10 free try-on credits</li>
            <li>💾 Save your try-on history</li>
            <li>🎨 Access to all garment brands</li>
            <li>📱 Share on social media</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Signup;